import {getRequest} from "./utilities/http";

export const fetchFloorPlan = async (floorPlanID:number) => {
    return await getRequest('/floor-plan/' + floorPlanID);
};